import { useContext } from "react";

import { ClientDeletionContext } from "../contexts/ClientDeletion/ClientDeletionContext";

const useClientDeletion = () => {
  const context = useContext(ClientDeletionContext);

  if (!context) {
    throw new Error("useClientDeletion must be used within a ClientDeletionProvider");
  }

  return context;
};

export default useClientDeletion;
